import { useState, useEffect } from "react"
import { SampleTraining, VideoUrls, TrainingAndVideo } from "../Interface"
import { defaultTraining, defaultVideoUrl } from "../Util/index"

export const useGetTrainingAndVideo = ({ location }): TrainingAndVideo => {
  const [training, setContent] = useState<SampleTraining>(defaultTraining)
  const [videoUrls, setVideoUrls] = useState<VideoUrls>(defaultVideoUrl)

  useEffect(() => {
    if (typeof window === "undefined") {
      return
    }
    setContent(location.state.training)
    setVideoUrls(location.state.videoUrls)
  }, [])

  return { training, videoUrls }
}
